import axios from "axios";

const BASE_URL = import.meta.env.VITE_JOBSOURCE_BASE_URL;

const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/users/register`, userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Fehler bei der Registrierung:", error);
    throw error;
  }
};

const confirmUser = async (token) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/api/users/confirm`,
      null,
      {
        params: { token },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status !== 200) {
      console.error("Fehlerhafte Antwort:", response);
      throw new Error(response.data.message || "Fehler bei der Bestätigung");
    }

    console.debug("Bestätigungsantwort:", response.data);
    return response.data;
  } catch (error) {
    // Fehler wird hier nur geloggt, wenn keine weiteren Informationen vorhanden sind.
    if (!error.response || !error.response.data) {
      console.error("Fehler bei der Bestätigung:", error);
    }
    // Fehler einfach werfen, um nur eine Fehlermeldung im Frontend zu haben
    throw new Error(error.response?.data?.message || "Fehler bei der Bestätigung");
  }
};

export default { registerUser, confirmUser };